<template>
	<div>
		<div class="breadcrumbs" id="breadcrumbs">
			<router-link class="breadcrumb-link" to="/billing/">Billing & Payments</router-link> &gt;
			<router-link class="breadcrumb-link" to="/billing/payment-documents">Team Payment Documents</router-link>
		</div>
		<h3>
			Team Payment Documents
			<span class="buttons">
          <a class="ws-button" @click="documentRequestType = 'invoice'; modals.paymentDocumentRequestModal = true">Request New Invoice</a>
          <a class="ws-button" @click="documentRequestType = 'receipt'; modals.paymentDocumentRequestModal = true">Request New Receipt</a>
        </span>
		</h3>

		<div class="ws-filters" style="float: right;">
			<div class="ws-filter ws-filter-select">
				<label>Document Type:</label>
				<select v-model="pageParams.filters.type.val" @change.prevent="filterDocumentType($event)">
					<option value="null">All Document Types</option>
					<option value="invoice">Invoices</option>
					<option value="receipt">Receipts</option>
					<option value="request">Requests</option>
				</select>
			</div>
		</div>

		<table id="payment-documents"  class="worksends-table">
			<thead>
			<tr>
				<th class="field-date">Date</th>
				<th class="field-name">File</th>
				<th class="field-type">Type</th>
				<th class="field-actions">Actions</th>
			</tr>
			</thead>
			<tbody>
			<tr v-for="item in index.data" :data-type="item.type">
				<td class="field-date" data-label="Date"><div class="value">{{ item.created_at }}</div></td>
				<td class="field-file" data-label="File"><div class="value"><a :href="downloadFileUrl(item.id)"><div :class="{'file-icon': true, ['file-icon-' + item.extension]: true}">{{ item.extension }}</div>{{ item.name }}</a></div></td>
				<td class="field-type" data-label="Type"><div class="value">{{ item.type}}</div></td>
				<td class="field-actions" data-label="Actions"><div class="value"><a :href="downloadFileUrl(item.id)">Download</a></div></td>
			</tr>
			</tbody>
		</table>
		<ws-table-meta :meta="index.meta" :sum="'You have % payment documents '+summaryTypeExtra+' available.'"></ws-table-meta>

		<payment-document-request-modal v-if="modals.paymentDocumentRequestModal" @created="onPaymentDocumentRequest" :team-id="team.id" :document-type="documentRequestType"></payment-document-request-modal>
	</div>
</template>

<script>
import PaymentDocumentRequestModal from '@/pages/billing/PaymentDocumentRequestModal';

export default {
	name: "BillingPaymentDocumentsIndex",
	components: {PaymentDocumentRequestModal},
	data() {
		return {
			pageParams: {
				pageOptions: {page:1, sortBy:[], sortDesc:[], itemsPerPage: 10},
				search: {val: ""},
				filters: { type: {val: null, type: 'single'},  }
			},
			documentType: '',
			documentRequestType: 'invoice',
			documentRequestSent: false,
		}
	},
	methods: {
		async getPage(params) {
			await this.getPageHandler({
				waitName: 'payment_documents.index',
				action: 'fetchPaymentDocuments', // vuex action
				pageParams: this.pageParams,
				isInit: params ? params.init : false, // parse from url query params
				pushRoute: false, // push pagination params and search q to route
				resetPagination: params ? params.resetPagination : false, // new search input -> need to reset page & sorting
			});
		},
		async fetchData() {
			await this.dispatchWaitAndNotify('fetchTeam', null, false, true);
		},
		onPaymentDocumentRequest() {
			this.documentRequestSent = true;
			this.modals.paymentDocumentRequestModal = false;
		},
		downloadFileUrl(docId) {
			return `/api/v1/teams/${this.team.id}/payment-documents/${docId}/download`;
		},
		async filterDocumentType(event) {
			this.getPage();
			/*let type = event.target.value;
			if (type) await this.dispatchWaitAndNotify('fetchPaymentDocumentsOfType', type, false, true);
			else await this.dispatchWaitAndNotify('fetchPaymentDocuments', null, false, true);*/
		},
	},
	mounted() {
		this.pageParams.pageOptions.itemsPerPage = this.itemsPerPageCookie(this.$options.name);
		this.getPage({init:true});
		this.fetchData();
	},
	computed: {
		index() {
			return this.$store.state.paymentDocument.index;
		},
		team() {
			return this.$store.state.team.detail;
		},
		modals() {
			return this.$store.state.modals;
		},
		summaryTypeExtra() {
			return this.documentType?'of type '+this.documentType:'';
		}
	},
}
</script>

<style scoped>
.worksends-table#ipayment-documents .field-date {
	white-space: nowrap;
}
.worksends-table#payment-documents .field-name {
	width: 60%;
}
.worksends-table#payment-documents .field-type {
	width: 120px;
}
</style>
